import { useMutation, useQueryClient } from '@tanstack/react-query';

import { clientsService } from '../services';
import type { CreateDormantClientInput } from '../types';

import { clientsKeys } from './useClients';

export function useCreateDormantClient() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateDormantClientInput) => clientsService.createShadow(input),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: clientsKeys.lists() });
    },
  });
}
